export default function () {
    const subnavTriggers = Array.from(document.querySelectorAll(".subnav-trigger"));
    const navTrigger = document.querySelector("#menu-toggler");

    // Subnav stuff
    subnavTriggers.forEach((trigger) =>
        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            const navItem = e.currentTarget.closest(".navigation-categories__item");
            const isOpen = navItem.classList.contains("navigation-categories__item--is-open");

            navItem.classList.toggle("navigation-categories__item--is-open", !isOpen);
        })
    );

    if (navTrigger) {
        navTrigger.addEventListener("click", (e) => {
            e.preventDefault();
            document.body.classList.toggle("menu-open");
        });
    }
}
